import { booleanAttribute, Component, input } from '@angular/core';

import { buttonsRowAlign, TButtonsRowAlign } from '../../models/buttons-row-options';

// Generieke knoppenrij voor knoppen in de pagina-inhoud (een onderdeel van de pagina, niet de
// hele pagina — die horen in de footer). Geeft de knoppen dezelfde tussenruimte als in de
// footer: de host draagt .horizontal-buttons/.vertical-buttons, waarop buttons.scss de marges
// tussen de knoppen zet. Ruimte boven/onder via --shape-button-action-row-margin-block.
// Standaard links uitgelijnd (inhoud leest van links); [align] voor center/end.
@Component({
    selector: 'app-buttons-row',
    template: '<ng-content />',
    styleUrls: ['./buttons-row.component.scss'],
    standalone: true,
    host: {
        '[class.horizontal-buttons]': '!input_vertical$$()',
        '[class.vertical-buttons]': 'input_vertical$$()',
        '[attr.data-align]': 'input_align$$()',
    },
})
export class ButtonsRowComponent
{
    input_align$$    = input<TButtonsRowAlign>(buttonsRowAlign.start,  { alias: 'align' });
    input_vertical$$ = input(false,                                   { transform: booleanAttribute, alias: 'vertical' });
}
